import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mono-common-loading-animation',
  templateUrl: './loading-animation.component.html',
  styleUrls: ['./loading-animation.component.scss']
})
export class LoadingAnimationComponent implements OnInit {
  @Input() spinnerColour?: string = '#fff';
  constructor() {
  }

  ngOnInit(): void {
  }

}
